<ul>
  <li *ngFor="let field of matterData">
    {{field.label }}: {{ field.value}}
  </li>
</ul>
